import { render, staticRenderFns } from "./TaskWorkflowRestored.vue?vue&type=template&id=193c57c0&scoped=true"
import script from "./TaskWorkflowRestored.vue?vue&type=script&lang=js"
export * from "./TaskWorkflowRestored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193c57c0",
  null
  
)

export default component.exports